import { useEffect } from "react";
import "@/App.css";
import "lenis/dist/lenis.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { InstagramSection } from "@/components/InstagramSection";
import { Loader } from "@/components/Loader";
import { Cursor } from "@/components/Cursor";
import Home from "@/pages/Home";
import BrandPage from "@/pages/BrandPage";
import Legal from "@/pages/Legal";
import AdminPage from "@/pages/Admin";
import { startLenis, scrollToTarget } from "@/lib/scroll";

const ScrollReset = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) scrollToTarget(0, { immediate: true });
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const stop = startLenis();
    return () => stop();
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <Loader />
        <Cursor />
        <ScrollReset />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/brands/:slug" element={<BrandPage />} />
          <Route path="/terms" element={<Legal title="Terms and Conditions" />} />
          <Route path="/privacy" element={<Legal title="Privacy Policy" />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <InstagramSection />
        <Footer />
        <Toaster position="bottom-right" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
